import { useState } from "react";
import { useHistory } from "react-router-dom";
import MapComponent from "../../components/Map";
import CheckBoxComponent from "../../components/MultiSelector";
import {
  activityOptions,
  ADMIN,
  ERR_TITLE,
  SEND_ADMIN_MSG_ERR
} from "../../util/CommonConstants";
import firebase from "firebase/app";

import "react-datetime-picker/dist/DateTimePicker.css";
import "react-calendar/dist/Calendar.css";
import "react-clock/dist/Clock.css";
import "../../static/css/Activities.css";
import { TOKEN_KEY } from "../../util/Auth";
import EventColl from "../../firebase/EventsColl";
import MessagesUserColl from "../../firebase/MessagesUserColl";
import { arrayToFormattedString } from "../../util/Util";
import UtilDate from "../../util/UtilDate";
import { ORG_ID } from "../../util/CommonConstants";
import CalendarSelector from "../../components/CalendarSelector";
import Footer from "../../components/Footer";

export const EventCreateForm = (props) => {
  const history = useHistory();

  const currentUser = JSON.parse(localStorage.getItem(TOKEN_KEY));
  const [eventRecord, setEventRecord] = useState({
    contact_name: currentUser.first_name + " " + currentUser.last_name,
    contact_phone: currentUser.phone,
    contact_email: currentUser.email,
    organizer_id: currentUser.id,
    organization: localStorage.getItem(ORG_ID),
    frequency: null
  });

  const [isLoading, setIsLoading] = useState(false);

  const handleLocationUpdate = (lat, long) => {
    let record = eventRecord;
    record["geolocation"] = {
      lat,
      long
    };
    setEventRecord(record);
  };

  const handleEventStart = (startDate, startTime) => {
    setEventRecord({
      ...eventRecord,
      start_time: startTime,
      start_date: startDate
    });
  };

  const handleEventEnd = (endTime) => {
    setEventRecord({
      ...eventRecord,
      end_time: endTime
    });
  };

  const handleEventRecurrence = (interval) => {
    setEventRecord({
      ...eventRecord,
      frequency: interval
    });
  };

  const handleSelectedActivities = (event) => {
    const value = event.target.value;
    let record = eventRecord;
    let selectedActivities = record.activities ? record.activities : [];

    if (selectedActivities.includes(value)) {
      selectedActivities = selectedActivities.filter((item) => item !== value);
    } else if (selectedActivities) {
      selectedActivities.push(value);
    } else {
      selectedActivities = [value];
    }
    setEventRecord({ ...record, activities: selectedActivities });
  };

  const runValidations = () => {
    let errors = [];

    //required fields
    if (!eventRecord.contact_email || !eventRecord.contact_name) {
      errors.push("Missing event coordinator contact info.");
    }

    if (!eventRecord.organization) {
      errors.push("Missing organization ID.");
    }

    if (!eventRecord.title || eventRecord.title.trim().length < 1) {
      errors.push("Missing the title, please enter a title for this event.");
    }

    if (!eventRecord.description || eventRecord.description.trim().length < 1) {
      errors.push(
        "Missing the description, please enter a description for this event."
      );
    }

    if (!eventRecord.activities || eventRecord.activities.length < 1) {
      errors.push(
        "Missing activities, please select one or more activities for this event."
      );
    }

    //additional validations
    if (eventRecord.title && eventRecord.title.length > 40) {
      errors.push(
        "The full title for the event is too long, please limit to under 40 characters."
      );
    }

    if (errors.length > 0) {
      alert("We found a few things..." + arrayToFormattedString(errors, true));
    }
    return errors;
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Check email verification
    const user = firebase.auth().currentUser;
    if (!user || !user.emailVerified) {
      alert(
        "Please verify your email address before creating an event. Check your inbox for the verification email."
      );
      setIsLoading(false);
      return;
    }

    let errors = runValidations();
    if (errors.length > 0) {
      setIsLoading(false);
      return;
    }
    console.log(errors);

    //store unapproved event
    let eventResponse = await EventColl.shared.createEvent(eventRecord, false);
    if (!eventResponse) {
      alert(ERR_TITLE, SEND_ADMIN_MSG_ERR);
      setIsLoading(false);
      return;
    }

    const message = createMessage();
    console.log(message);
    let firestoreMessage =
      await MessagesUserColl.shared.createIndividualMessage(message, ADMIN);

    if (!firestoreMessage) {
      alert(ERR_TITLE, SEND_ADMIN_MSG_ERR);
      setIsLoading(false);
      return;
    }

    history.push("/event/complete");
    setIsLoading(false);
  };

  const createMessage = () => {
    let subject = "Create Event Request";

    let message = "";
    message +=
      "This is an auto-generated message for an Event request. Go to the 'Approve Events' page in the Admin Tab to add this event to the 808 Cleanups Calendar. This request was submitted through the Web App, so the user may respond through email/SMS instead of the Mobile App.";
    message += "\n\nName: " + eventRecord.contact_name;
    message += "\n\nPhone: " + eventRecord.contact_phone;
    message += "\n\nEmail: " + eventRecord.contact_email;
    message += "\n\nOrganization: " + eventRecord.organization;
    message += "\n\nTitle: " + eventRecord.title;
    message +=
      "\n\nAddress: " +
      (eventRecord.address ? eventRecord.address + ", " : "") +
      (eventRecord.city ? eventRecord.city + ", " : "") +
      (eventRecord.zip ? eventRecord.zip : "");
    message +=
      "\n\nCoordinates: " +
      eventRecord.geolocation.lat +
      ", " +
      eventRecord.geolocation.long;
    message +=
      "\n\nEvent Date: " + UtilDate.getDateShortWithDay(eventRecord.start_date);
    message +=
      "\n\nEvent Start Time: " +
      UtilDate.getTimeFromDate(eventRecord.start_time);
    message +=
      "\n\nEvent End Time: " + UtilDate.getTimeFromDate(eventRecord.end_time);
    message += "\n\nDescription: " + eventRecord.description;
    message +=
      "\n\nActivities: " + arrayToFormattedString(eventRecord.activities);
    message +=
      "\n\nWhat to Bring: " +
      (eventRecord.what_to_bring ? eventRecord.what_to_bring : "");
    message +=
      "\n\nWhere to Meet: " +
      (eventRecord.where_to_meet ? eventRecord.where_to_meet : "");

    return { subject, message };
  };

  return (
    <div
      style={{
        minHeight: "100vh"
      }}
    >
      <h1>📅 Schedule Your Event</h1>
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          backgroundColor: "white",
          borderRadius: "12px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          padding: "40px",
          marginBottom: "40px"
        }}
      >
        {/* Progress Indicator */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "30px",
            padding: "0 20px"
          }}
        >
          {[
            { label: "1. Basic Info", icon: "📝" },
            { label: "2. Details", icon: "📋" },
            { label: "3. Activities", icon: "🏃‍♂️" },
            { label: "4. Submit", icon: "✅" }
          ].map((step, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                flex: 1
              }}
            >
              <div
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  backgroundColor: "#e3f2fd",
                  color: "white",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "18px",
                  marginBottom: "8px"
                }}
              >
                {step.icon}
              </div>
              <span
                style={{
                  fontSize: "12px",
                  color: "#6c757d",
                  textAlign: "center"
                }}
              >
                {step.label}
              </span>
            </div>
          ))}
        </div>

        {/* Form Sections */}
        <form onSubmit={onSubmit}>
          {/* Section 1: Basic Information */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "25px",
              borderRadius: "8px",
              marginBottom: "25px"
            }}
          >
            <h3
              style={{
                color: "#2c5aa0",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}
            >
              📝 Basic Information
            </h3>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#495057"
                }}
              >
                Event Title *
              </label>
              <input
                type="text"
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "2px solid #e9ecef",
                  borderRadius: "6px",
                  fontSize: "16px",
                  transition: "border-color 0.3s ease"
                }}
                value={eventRecord.title || ""}
                onChange={(e) =>
                  setEventRecord({ ...eventRecord, title: e.target.value })
                }
                placeholder="Enter a descriptive title for your event"
                required
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#495057"
                }}
              >
                Event Description *
              </label>
              <textarea
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "2px solid #e9ecef",
                  borderRadius: "6px",
                  fontSize: "16px",
                  minHeight: "120px",
                  resize: "vertical"
                }}
                value={eventRecord.description || ""}
                onChange={(e) =>
                  setEventRecord({
                    ...eventRecord,
                    description: e.target.value
                  })
                }
                placeholder="Describe what volunteers can expect, the goals of the cleanup, and any important details..."
                required
              />
            </div>
          </div>

          {/* Section 2: Event Details */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "25px",
              borderRadius: "8px",
              marginBottom: "25px"
            }}
          >
            <h3
              style={{
                color: "#2c5aa0",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}
            >
              📋 Event Details
            </h3>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#495057"
                }}
              >
                Event Date & Time
              </label>
              <CalendarSelector
                handleEventStart={handleEventStart}
                handleEventEnd={handleEventEnd}
                handleEventRecurrence={handleEventRecurrence}
                eventStartDateTime={
                  eventRecord.start_time ? eventRecord.start_time : new Date()
                }
                eventEndTime={
                  eventRecord.end_time ? eventRecord.end_time : new Date()
                }
              />
            </div>

            <div style={{ marginBottom: "20px" }}>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#495057"
                }}
              >
                Event Location *
              </label>
              <div
                style={{
                  border: "2px solid #e9ecef",
                  borderRadius: "6px",
                  overflow: "hidden"
                }}
              >
                <MapComponent handleLocationUpdate={handleLocationUpdate} />
              </div>
              {eventRecord.geolocation && (
                <p
                  style={{
                    marginTop: "8px",
                    fontSize: "14px",
                    color: "#28a745",
                    fontWeight: "500"
                  }}
                >
                  ✅ Location selected: {eventRecord.geolocation.lat.toFixed(4)}
                  , {eventRecord.geolocation.long.toFixed(4)}
                </p>
              )}
            </div>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
                marginBottom: "20px"
              }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#495057"
                  }}
                >
                  What to Bring
                </label>
                <textarea
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "2px solid #e9ecef",
                    borderRadius: "6px",
                    fontSize: "16px",
                    minHeight: "100px",
                    resize: "vertical"
                  }}
                  value={eventRecord.what_to_bring || ""}
                  onChange={(e) =>
                    setEventRecord({
                      ...eventRecord,
                      what_to_bring: e.target.value
                    })
                  }
                  placeholder="List items volunteers should bring (gloves, water, etc.)"
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#495057"
                  }}
                >
                  Where to Meet
                </label>
                <textarea
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "2px solid #e9ecef",
                    borderRadius: "6px",
                    fontSize: "16px",
                    minHeight: "100px",
                    resize: "vertical"
                  }}
                  value={eventRecord.where_to_meet || ""}
                  onChange={(e) =>
                    setEventRecord({
                      ...eventRecord,
                      where_to_meet: e.target.value
                    })
                  }
                  placeholder="Describe the meeting point for volunteers"
                />
              </div>
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#495057"
                }}
              >
                Waiver URL
              </label>
              <input
                type="text"
                style={{
                  width: "100%",
                  padding: "12px",
                  border: "2px solid #e9ecef",
                  borderRadius: "6px",
                  fontSize: "16px"
                }}
                value={eventRecord.waiver_url || ""}
                onChange={(e) =>
                  setEventRecord({ ...eventRecord, waiver_url: e.target.value })
                }
                placeholder="https://example.com/waiver"
              />
            </div>
          </div>

          {/* Section 3: Activities */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "25px",
              borderRadius: "8px",
              marginBottom: "25px"
            }}
          >
            <h3
              style={{
                color: "#2c5aa0",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}
            >
              🏃‍♂️ Activities *
            </h3>
            <CheckBoxComponent
              handleCheckBoxChange={handleSelectedActivities}
              items={activityOptions}
              selectedItems={
                eventRecord.activities ? eventRecord.activities : []
              }
            />
          </div>

          {/* Section 4: Contact Information */}
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "25px",
              borderRadius: "8px",
              marginBottom: "30px"
            }}
          >
            <h3
              style={{
                color: "#2c5aa0",
                marginBottom: "20px",
                display: "flex",
                alignItems: "center",
                gap: "10px"
              }}
            >
              📞 Contact Information
            </h3>

            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "20px",
                marginBottom: "20px"
              }}
            >
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#495057"
                  }}
                >
                  Contact Name *
                </label>
                <input
                  type="text"
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "2px solid #e9ecef",
                    borderRadius: "6px",
                    fontSize: "16px"
                  }}
                  value={eventRecord.contact_name}
                  onChange={(e) =>
                    setEventRecord({
                      ...eventRecord,
                      contact_name: e.target.value
                    })
                  }
                  required
                />
              </div>
              <div>
                <label
                  style={{
                    display: "block",
                    marginBottom: "8px",
                    fontWeight: "600",
                    color: "#495057"
                  }}
                >
                  Contact Email *
                </label>
                <input
                  type="email"
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: "2px solid #e9ecef",
                    borderRadius: "6px",
                    fontSize: "16px"
                  }}
                  value={eventRecord.contact_email}
                  onChange={(e) =>
                    setEventRecord({
                      ...eventRecord,
                      contact_email: e.target.value
                    })
                  }
                  required
                />
              </div>
            </div>

            <div>
              <label
                style={{
                  display: "block",
                  marginBottom: "8px",
                  fontWeight: "600",
                  color: "#495057"
                }}
              >
                Contact Phone *
              </label>
              <input
                type="tel"
                style={{
                  width: "100%",
                  maxWidth: "300px",
                  padding: "12px",
                  border: "2px solid #e9ecef",
                  borderRadius: "6px",
                  fontSize: "16px"
                }}
                value={eventRecord.contact_phone}
                onChange={(e) =>
                  setEventRecord({
                    ...eventRecord,
                    contact_phone: e.target.value
                  })
                }
                required
              />
            </div>
          </div>

          {/* Submit Section */}
          <div
            style={{
              textAlign: "center",
              padding: "20px",
              backgroundColor: "#e3f2fd",
              borderRadius: "8px",
              marginBottom: "20px"
            }}
          >
            <button
              type="submit"
              disabled={isLoading}
              style={{
                backgroundColor: isLoading ? "#6c757d" : "#2c5aa0",
                color: "white",
                border: "none",
                padding: "15px 40px",
                borderRadius: "8px",
                fontSize: "18px",
                fontWeight: "600",
                cursor: isLoading ? "not-allowed" : "pointer",
                transition: "all 0.3s ease",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
              }}
              onMouseEnter={(e) => {
                if (!isLoading) {
                  e.target.style.backgroundColor = "#1e3a8a";
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 4px 8px rgba(0,0,0,0.2)";
                }
              }}
              onMouseLeave={(e) => {
                if (!isLoading) {
                  e.target.style.backgroundColor = "#2c5aa0";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.1)";
                }
              }}
            >
              {isLoading ? (
                <span>
                  <span style={{ marginRight: "8px" }}>⏳</span>
                  Creating Event...
                </span>
              ) : (
                <span>Submit Event</span>
              )}
            </button>
          </div>
        </form>
      </div>
      <Footer />
    </div>
  );
};
